export default __webpack_public_path__ + "static/media/764.9f4d562c.png";